<template>
  <router-view v-if="$route.path === '/login'" />
  <el-container v-else class="layout">
    <div v-if="mobileMenu" class="mobile-mask" @click="mobileMenu = false"></div>
    <el-aside width="250px" class="sidebar" :class="{ 'is-open': mobileMenu }">
      <div class="brand"><img class="brand-logo" src="/brand-logo.png?v=20261022b" alt="舞蹈花园 Logo"><span>舞蹈花园·芭蕾<small>BALLET GARDEN</small></span></div>
      <div class="side-caption">门店管理平台</div>
      <el-menu :default-active="$route.path" router background-color="#26383c" text-color="#bdcbc8" active-text-color="#fff" @select="mobileMenu = false">
        <el-menu-item index="/dashboard"><i class="el-icon-data-board"></i>总览</el-menu-item>
        <el-menu-item index="/classes"><i class="el-icon-date"></i>课程排期</el-menu-item>
        <el-menu-item index="/bookings"><i class="el-icon-s-claim"></i>预约与签到</el-menu-item>
        <el-menu-item index="/members"><i class="el-icon-user"></i>学员管理</el-menu-item>
        <el-menu-item index="/ledger"><i class="el-icon-tickets"></i>课时流水</el-menu-item>
      </el-menu>
      <div class="sidebar-bottom">舞蹈花园·芭蕾</div>
    </el-aside>
    <el-container>
      <el-header class="topbar"><el-button class="mobile-nav-button" type="text" icon="el-icon-s-fold" aria-label="打开菜单" @click="mobileMenu = true"></el-button><span class="breadcrumb">工作台 <i>/</i> <strong>{{ pageTitle }}</strong></span><el-button type="text" @click="logout">退出登录</el-button></el-header>
      <el-main><router-view /></el-main>
    </el-container>
  </el-container>
</template>
<script>
export default {
  data: () => ({ mobileMenu: false }),
  watch: { '$route.path' () { this.mobileMenu = false } },
  computed: {
    pageTitle () {
      return ({ '/dashboard': '总览', '/classes': '课程排期', '/bookings': '预约与签到', '/members': '学员管理', '/ledger': '课时流水' })[this.$route.path] || ''
    }
  },
  methods: {
    logout () { localStorage.removeItem('admin_token'); this.$router.replace('/login') }
  }
}
</script>
<style>
* { box-sizing: border-box; }
body { margin: 0; font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", sans-serif; background: #f7f5f1; color: #263439; }
.layout { min-height: 100vh; }
.sidebar { background: #26383c; min-height: 100vh; display: flex; flex-direction: column; }
.brand { height: 108px; display: flex; align-items: center; gap: 12px; padding: 0 22px; color: #fff; font-family: "Songti SC", "STSong", serif; font-size: 19px; letter-spacing: 1px; font-weight: 500; white-space: nowrap; }
.brand-logo { width: 48px; height: 48px; object-fit: contain; flex: 0 0 48px; }
.brand small { display: block; font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", sans-serif; font-size: 8px; color: #b5c0bd; letter-spacing: 2px; margin-top: 8px; }
.side-caption { color: #849997; font-size: 10px; letter-spacing: 3px; padding: 0 27px 14px; }
.sidebar .el-menu { border-right: 0; padding: 0 13px; }
.sidebar .el-menu-item { border-radius: 8px; margin: 3px 0; font-size: 13px; }
.sidebar .el-menu-item:hover { background: #364c50 !important; }
.sidebar .el-menu-item.is-active { background: #364c50 !important; box-shadow: inset 2px 0 0 #c1a48a; }
.sidebar .el-menu-item i { color: #b6c6c0; }
.sidebar-bottom { margin-top: auto; padding: 22px 27px; color: #b5c0bd; border-top: 1px solid #486064; font-size: 12px; }
.topbar { display: flex; justify-content: space-between; align-items: center; background: #fdfcf9; border-bottom: 1px solid #e9e6e0; color: #8b9692; font-size: 12px; height: 74px !important; padding: 0 39px; }
.breadcrumb i { font-style: normal; margin: 0 10px; color: #c3c8c2; }
.breadcrumb strong { color: #263439; font-weight: 600; }
.topbar .el-button--text { color: #59736c; }
.mobile-nav-button { display: none; font-size: 22px; margin-right: 12px; }
.el-main { padding: 42px 39px 65px; max-width: 1550px; width: 100%; }
.page-head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 29px; gap: 16px; }
.page-head h1 { margin: 0; font-family: "Songti SC", "STSong", serif; font-size: 34px; font-weight: 500; }
.page-head p { color: #89938f; font-size: 12px; margin: 9px 0 0; }
.panel { background: white; border: 1px solid #e8e4dd; border-radius: 12px; padding: 25px; box-shadow: 0 8px 26px rgba(39,51,52,.03); }
.toolbar { display: flex; gap: 10px; align-items: center; margin-bottom: 21px; }
.el-button { border-radius: 7px; font-weight: 500; }
.el-button--primary { background: #304348; border-color: #304348; }
.el-button--primary:hover, .el-button--primary:focus { background: #23373c; border-color: #23373c; }
.el-button--default:hover, .el-button--default:focus { color: #304348; border-color: #9dad9f; background: #fff; }
.el-input__inner, .el-select .el-input__inner { border-color: #e2e1da; border-radius: 7px; }
.el-input__inner:focus, .el-select .el-input__inner:focus { border-color: #79918b; }
.el-table th.el-table__cell { background: #f8f7f3; color: #88918d; font-weight: 600; }
.el-table td.el-table__cell { color: #586663; }
.el-tag--success { color: #4b7666; border-color: #dbe8df; background: #e9f1ed; }
.el-dialog { border-radius: 14px; }
@media (max-width: 768px) {
  body { background: #f7f5f1; }
  .layout > .el-container { min-width: 0; }
  .sidebar { position: fixed; left: 0; top: 0; bottom: 0; z-index: 2100; width: 260px !important; min-height: 100vh; transform: translateX(-100%); transition: transform .22s ease; box-shadow: 12px 0 32px rgba(27,43,43,.18); }
  .sidebar.is-open { transform: translateX(0); }
  .mobile-mask { position: fixed; inset: 0; z-index: 2099; background: rgba(22,34,35,.38); }
  .mobile-nav-button { display: inline-flex; align-items: center; padding: 8px 0; }
  .topbar { height: 58px !important; padding: 0 18px; }
  .breadcrumb { flex: 1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .breadcrumb i { margin: 0 6px; }
  .topbar > .el-button:last-child { padding-right: 0; }
  .el-main { padding: 22px 14px 42px; }
  .page-head { align-items: flex-start; margin-bottom: 18px; }
  .page-head h1 { font-size: 26px; }
  .page-head p { line-height: 1.5; margin-top: 5px; }
  .page-head > .el-button { flex: 0 0 auto; margin-top: 3px; padding: 10px 12px; }
  .panel { padding: 16px; border-radius: 10px; overflow-x: auto; }
  .toolbar { flex-wrap: wrap; gap: 8px; margin-bottom: 16px; }
  .toolbar .el-input, .toolbar .el-select { width: 100% !important; }
  .el-table { min-width: 680px; }
  .el-row { margin-left: 0 !important; margin-right: 0 !important; }
  .el-row > [class*="el-col-"] { width: 100%; padding-left: 0 !important; padding-right: 0 !important; margin-bottom: 14px; }
  .el-dialog { width: calc(100% - 28px) !important; margin: 7vh auto 0 !important; }
  .el-dialog__header { padding: 19px 18px 12px; }
  .el-dialog__body { padding: 16px 18px; max-height: 67vh; overflow-y: auto; }
  .el-dialog__footer { padding: 10px 18px 18px; }
  .el-form-item__label { float: none; display: block; width: auto !important; text-align: left; line-height: 1.4; padding: 0 0 7px; }
  .el-form-item__content { margin-left: 0 !important; line-height: 1.4; }
  .el-form-item { margin-bottom: 17px; }
  .el-date-editor.el-input, .el-date-editor.el-input__inner { width: 100% !important; }
  .el-radio-group { display: flex; flex-wrap: wrap; gap: 6px; }
  .el-radio-button__inner { border-left: 1px solid #dcdfe6 !important; border-radius: 4px !important; }
}
</style>
